module.exports = __webpack_public_path__ + "img/suzhou.915b6a8a.jpg";